import { useRenderContext } from './RenderContext';
export function Link(props) {
    const { renderLink } = useRenderContext();
    return renderLink(props);
}
